export const SET_VIEW_STATE = "SET_VIEW_STATE";

export const SET_FIRST_NAME = "SET_FIRST_NAME";
export const SET_LAST_NAME = "SET_LAST_NAME";
export const SET_DOB = "SET_DOB";
